// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"316":"ad2866b8","501":"bc98253f"}[chunkId] || chunkId) + "." + {"121":"d16cb7a4a8519162","316":"f0195b9adf08501e","501":"cf5cdd0ffd30c2b3","822":"3bddd9397fe6b0e9"}[chunkId] + ".js";
};